import React from 'react';
import ScrollbarCustom from 'react-scrollbars-custom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const SCROLLBAR_WIDTH_PX = 16;

/* eslint-disable react/jsx-props-no-spreading */

class Scrollbar extends React.Component {
  constructor(props) {
    super(props);

    this.onWindowResize = this.onWindowResize.bind(this);

    this.state = {
      height: 0,
    };
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  async componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  }

  onWindowResize() {
    this.setState({ height: window.innerHeight });
  }

  render() {
    const {
      className: rendererClassName,
      contentClassName,
      trackYClassName,
      fullHeight,
      ...props
    } = this.props;

    return (
      <ScrollbarCustom
        {...props}
        removeTracksWhenNotUsed
        renderer={({ elementRef, style, className, ...restProps }) => (
          <span
            {...restProps}
            ref={elementRef}
            className={classNames({
              [className]: className,
              [rendererClassName]: rendererClassName,
            })}
            style={{
              ...style,
              height: fullHeight ? this.state.height : style.height,
            }}
          />
        )}
        wrapperProps={{
          renderer: ({ elementRef, style, ...restProps }) => (
            <span
              {...restProps}
              ref={elementRef}
              style={{
                ...style,
                right:
                  style.right === 0 ? 0 : SCROLLBAR_WIDTH_PX || style.right,
              }}
            />
          ),
        }}
        contentProps={{
          renderer: ({ elementRef, className, ...restProps }) => (
            <span
              {...restProps}
              ref={elementRef}
              className={classNames({
                [className]: className,
                [contentClassName]: contentClassName,
              })}
            />
          ),
        }}
        trackYProps={{
          renderer: ({ elementRef, style, className, ...restProps }) => (
            <span
              {...restProps}
              ref={elementRef}
              className={classNames({
                [className]: className,
                [trackYClassName]: trackYClassName,
              })}
              style={{
                ...style,
                width: SCROLLBAR_WIDTH_PX || style.width,
                paddingLeft: '2px',
                paddingRight: '2px',
              }}
            />
          ),
        }}
      />
    );
  }
}

Scrollbar.defaultProps = {
  //
};

Scrollbar.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  trackYClassName: PropTypes.string,
};

export default Scrollbar;
